import { ReactComponent as OrigEdit } from "@assets/redesign/icons/inputEdit.svg";
import { ReactComponent as Trash } from "@assets/redesign/icons/trash.svg";
import { ReactComponent as WlpEdit } from "@components/WLP202603/assets/redesign/icons/inputEdit.svg";
import mainLocationsStore from "@mobx/store/locations";
import { RackStore } from "@mobx/store/locations/interfaces";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { makeNotifs } from "@utils/makeNotifs";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import styles from "./RackHeader.module.scss";
import { WLP202603 } from "../../../config";

const Edit = WLP202603 ? WlpEdit : OrigEdit;

export interface IRackHeader3Props {
  rackStore: RackStore;
}

const useControl = (props: IRackHeader3Props) => {
  const { onSuccess } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const [isEditRackNum, setIsEditRackNum] = useState(false);
  const buildingStore = mainLocationsStore.activeLocation?.activeBuilding;
  

  const onStrtEdit = () => {
    if (buildingStore?.isLocked) return;
    setIsEditRackNum(true);
  };

  const onDelete = async () => {
    const r = await buildingStore?.deleteRack(props.rackStore.rack.id);
    if (r) onSuccess(ok.success);
  };

  const onEditRack = () => {
    props.rackStore.showRackModalForEdit();
  };

  return {
    isEditRackId: isEditRackNum,
    rackBLI: props.rackStore.rack.rack_id,

    onDelete,
    onEditRack,
    onStrtEdit,
  };
};

const RackHeader3 = observer((props: IRackHeader3Props) => {
  const control = useControl(props);

  return (
    <div className={cn(styles.wrapper)}>
      <div className={cn(styles.rack_id)}>
        <span className={styles.rackBLI} onWheel={(e) => e.currentTarget.blur()}>{control.rackBLI}</span>
      </div>
      { props.rackStore.isDeletable && 
        <Trash className={styles.del} onClick={control.onDelete} /> 
      }
      <Edit className={styles.edit} onClick={control.onEditRack} />
    </div>
  );
});

RackHeader3.displayName = "RackHeader3";

export default RackHeader3;
